/* MAIN */
const RETRY_INTERVAL = 250;
/* EXPORT */
export { RETRY_INTERVAL };
